/**
 * Which management routes actually have a left panel.
 *
 * Two places need the same answer and they must not be able to disagree: the panel decides
 * whether to RENDER, and the shell decides whether to RESERVE the 281px column the content
 * pane offsets itself by. When only one of them knew — which is what happened when Global
 * Configurations' panel was deleted — the page keeps an empty column beside a full-width
 * list.
 *
 * The route is read from the path rather than from router state because that is where the
 * panel has always read it from, and both callers run outside the route's own component.
 */

const PANEL_ROUTES: string[] = ["settings", "apps", "ui-kit", "cloud", "board", "issue"];

/** The path segment the panel keys on: `/{domain}/{section}/…`. */
export const managementSectionOf = (pathname: string): string => {
  let path: string = pathname.startsWith("/") ? pathname.substring(1) : pathname;
  if (path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const section: string = path.split("/")[1] ?? "";
  // The route is `projects`; every consumer calls the section "Apps".
  return section === "projects" ? "apps" : section.toLowerCase();
};

export const hasManagementLeftPanel = (pathname: string): boolean =>
  PANEL_ROUTES.includes(managementSectionOf(pathname));
